

export class ReferenceIdDto {
    externalRefNo: number;
    companyCode: string;
    unitCode: string;
    constructor(
        externalRefNo: number,
        companyCode: string,
        unitCode: string,
    ) {
        this.externalRefNo = externalRefNo;
        this.companyCode = companyCode;
        this.unitCode = unitCode;
    }

}